var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",class:{ 'app--sticky': _vm.offcanvasVisible },attrs:{"id":"app"}},[_c('AppLoading'),_c('router-view'),_c('Dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }